import { render, staticRenderFns } from "./AddBaseDataModal.vue?vue&type=template&id=6b0489c5&"
import script from "./AddBaseDataModal.vue?vue&type=script&lang=js&"
export * from "./AddBaseDataModal.vue?vue&type=script&lang=js&"
import style0 from "./AddBaseDataModal.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports